import { render, staticRenderFns } from "./AddDocument.vue?vue&type=template&id=0b06e8c4"
import script from "./AddDocument.vue?vue&type=script&lang=js"
export * from "./AddDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports